module.exports = __webpack_public_path__ + "static/img/slide1_x4.72e21da.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide1_x4.webp
// module id = VUzi
// module chunks = 1